import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

export interface Property {
  id: string;
  beds24_property_id: number;
  nom: string;
  descripcio: string | null;
  adreca: string | null;
  ciutat: string | null;
  codi_postal: string | null;
  pais: string | null;
  timezone: string | null;
  moneda: string | null;
  telefon: string | null;
  email: string | null;
  web: string | null;
  actiu: boolean;
  created_at: string;
  updated_at: string;
  last_sync_at: string | null;
  total_rooms?: number;
  total_units?: number;
}

export function useProperties() {
  return useQuery<Property[]>({
    queryKey: ['properties'],
    queryFn: async () => {
      const response = await api.get('/properties');
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
